import { render, staticRenderFns } from "./AlchemyResourceArc.vue?vue&type=template&id=18cd169c&scoped=true"
import script from "./AlchemyResourceArc.vue?vue&type=script&lang=js"
export * from "./AlchemyResourceArc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cd169c",
  null
  
)

export default component.exports